import { PanelMenuDesignTokens } from '@primeuix/themes/aura/panelmenu';

export const panelMenuTokens: PanelMenuDesignTokens = {
  root: {
    gap: '0.5rem',
    transitionDuration: '{transition.duration}',
  },
  panel: {
    background: '{content.background}',
    borderColor: '{content.border.color}',
    borderWidth: '1px',
    borderRadius: '{content.border.radius}',
    color: '{content.color}',
    padding: '0.25rem 0.25rem',
    first: {
      borderWidth: '1px',
      topBorderRadius: '{content.border.radius}',
    },
    last: {
      borderWidth: '1px',
      bottomBorderRadius: '{content.border.radius}',
    },
  },
  item: {
    focusBackground: '{navigation.item.focus.background}',
    focusColor: '{navigation.item.focus.color}',
    color: '{navigation.item.color}',
    gap: '0.5rem',
    padding: '{navigation.item.padding}',
    borderRadius: '{content.border.radius}',
    icon: {
      color: '{navigation.item.icon.color}',
      focusColor: '{navigation.item.icon.focus.color}',
    },
  },
  submenu: {
    indent: '1rem',
  },
  submenuIcon: {
    color: '{navigation.submenu.icon.color}',
    focusColor: '{navigation.submenu.icon.focus.color}',
  },
};
